export default "/_next/static/fonts/tt_norms_pro_extrabold_italic-1c415a62d68578d542f9e5e92aecde37.woff";